import { useQuery } from 'react-query';
import { WushuStyleAPI } from 'api/admin/wushuStyle';
import { WUSHU_STYLES } from 'helpers/constants';

export default function useWushuStyles() {
  return useQuery(WUSHU_STYLES, WushuStyleAPI.getAll);
}
